// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function RaBooleanField(theme): object {
  return {
    RaBooleanField: {
      styleOverrides: {
        root: {
          '& svg[data-testid="true"]': {
            color: theme.palette.success.main,
          },
          '& svg[data-testid="false"]': {
            color: theme.palette.error.main,
          },
        },
      },
    },
  }
}
